(<template>
  <div :class="styleClass">
    <h1 id="title-new-souvenir" v-if="!loadedForm" v-translate>Add new souvenir</h1>
    <h1 id="title-edit-souvenir" v-else v-translate>Edit souvenir</h1>
    <el-form :model="souvenirForm"
             :rules="rules"
             ref="souvenirForm"
             label-position="left"
             label-width="12em">
      <el-form-item prop="name">
        <span slot="label" v-translate>Name</span>
        <el-input id="input-name"
                  :placeholder="namePlaceholder.hu"
                  v-model="souvenirForm.name.hu"
                  @focus="showName=true"></el-input>
        <el-collapse-transition>
          <div v-show="showName">
            <el-input id="input-name-en"
                      class="input-style"
                      :placeholder="namePlaceholder.en"
                      v-model="souvenirForm.name.en"></el-input><br />
            <el-input id="input-name-ro"
                      class="input-style"
                      :placeholder="namePlaceholder.ro"
                      v-model="souvenirForm.name.ro"></el-input>
          </div>
        </el-collapse-transition>
      </el-form-item>      
      <el-form-item prop="description">
        <span slot="label" v-translate>Description</span>
        <el-input id="input-desciption"
                  type="textarea"
                  :placeholder="descPlaceholder.hu"
                  v-model="souvenirForm.description.hu"
                  @focus="showDesc=true"></el-input>
        <el-collapse-transition>
          <div v-show="showDesc">
            <el-input id="input-desciption-en"
                      class="input-style"
                      type="textarea"
                      :placeholder="descPlaceholder.en"
                      v-model="souvenirForm.description.en"></el-input>
            <el-input id="input-desciption-ro"
                      class="input-style"
                      type="textarea"
                      :placeholder="descPlaceholder.ro"
                      v-model="souvenirForm.description.ro"></el-input>
          </div>
        </el-collapse-transition>
      </el-form-item>
      <el-form-item prop="price">
        <span slot="label" v-translate>Price</span>
        <el-input id="input-price" type="number" min=0
                  :placeholder="this.$gettext('Please enter the price of the item')"
                  v-model="souvenirForm.price"/>
      </el-form-item>  
      <el-form-item prop="images">
        <span slot="label" v-translate>Images</span>
        <image-uploader :images="souvenirForm.images"
                        @image-added="addImage"
                        @image-removed="removeImage"></image-uploader>
      </el-form-item>
      <el-form-item>
        <el-button v-if="loadedForm" @click="cancel">
          <span v-if="loadedForm" v-translate>Cancel</span>
        </el-button>
        <el-button id="button-upload" type="primary" @click="submitForm('souvenirForm')">
          <span v-if="loadedForm" v-translate>Update</span>
          <span v-else v-translate>Upload</span>
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>)

(<script>
import axios from 'axios'
import ImageUploader from './Image-Uploader.vue'

export default {
  name: 'souvenir-upload-form',
  components: {
    'image-uploader': ImageUploader
  },
  props: ['loaded-form'],
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (vm.$session.exists()) {
        next()
      } else {
        next('/signin')
      }
    })
  },
  data () {
    var styleClass = this.loadedForm ? 'update-form' : 'form'
    var souvenirForm = this.loadedForm || {
      name: {
        hu: '',
        en: '',
        ro: ''
      },
      description: {
        hu: '',
        en: '',
        ro: ''
      },
      images: []
    }
    souvenirForm.removedImages = []
    souvenirForm.newImages = []
    return {
      namePlaceholder: {
        hu: this.$gettext('Name in Hungarian'),
        en: this.$gettext('Name in English'),
        ro: this.$gettext('Name in Romanian')
      },
      descPlaceholder: {
        hu: this.$gettext('Description in Hungarian'),
        en: this.$gettext('Description in English'),
        ro: this.$gettext('Description in Romanian')
      },
      styleClass,
      showName: false,
      showDesc: false,
      souvenirForm,
      rules: {
        name: {
          type: 'object',
          required: true,
          fields: {
            hu: {type: 'string', required: true, trigger: 'blur', message: this.$gettext('Please add name')},
            en: {type: 'string', required: true, trigger: 'blur', message: this.$gettext('Please add name')},
            ro: {type: 'string', required: true, trigger: 'blur', message: this.$gettext('Please add name')}
          }
        },
        description: {
          type: 'object',
          required: true,
          fields: {
            hu: [
              {type: 'string', required: true, message: this.$gettext('Please add description')},
              { max: 10000, message: this.$gettext('Max description length is 10000 characters'), trigger: 'blur' }
            ],
            en: [
              {type: 'string', required: true, message: this.$gettext('Please add description')},
              { max: 10000, message: this.$gettext('Max description length is 10000 characters'), trigger: 'blur' }
            ],
            ro: [
              {type: 'string', required: true, message: this.$gettext('Please add description')},
              { max: 10000, message: this.$gettext('Max description length is 10000 characters'), trigger: 'blur' }
            ]
          }
        },
        images: {
          type: 'array',
          required: true,
          message: this.$gettext('Please add images')
        },
        price: {
          required: true,
          message: this.$gettext('Please enter the price of the item or validate the number')
        }
      }
    }
  },
  methods: {
    substract (a, b) {
      return a.filter(element => b.indexOf(element) < 0)
    },
    uploadForm () {
      const tempPrice = this.souvenirForm.price
      if ((tempPrice != null && !tempPrice) || tempPrice < 0 || tempPrice > 10000000) {
        return null
      }
      axios({
        method: 'post',
        url: `${process.env.SERVER_URL}/souvenirs`,
        headers: {'Content-Type': 'application/json'},
        data: this.souvenirForm,
        withCredentials: true
      })
      .then(response => {
        this.$message({
          type: 'success',
          message: response.data || response.statusText
        })
        this.$router.push('/souvenirs/list')
      })
      .catch(error => {
        var msg
        if (error.response) {
          msg = error.response.data || error.response.statusText
        } else {
          msg = error.message
        }
        this.$message({
          type: 'error',
          message: msg
        })
      })
    },
    updateForm () {
      const tempPrice = this.souvenirForm.price
      if ((tempPrice != null && !tempPrice) || tempPrice < 0 || tempPrice > 10000000) {
        return null
      }
      axios({
        method: 'put',
        url: `${process.env.SERVER_URL}/souvenirs/${this.souvenirForm.id}`,
        headers: {'Content-Type': 'application/json'},
        data: this.souvenirForm,
        withCredentials: true
      })
      .then(response => {
        this.$message({
          type: 'success',
          message: response.data || response.statusText
        })
        this.$emit('close-edit')
      })
      .catch(error => {
        var msg
        if (error.response) {
          msg = error.response.data || error.response.statusText
        } else {
          msg = error.message
        }
        this.$message({
          type: 'error',
          message: msg
        })
      })
    },
    cancel () {
      this.$confirm(this.$gettext('Are you sure to close?'), {
        confirmButtonText: this.$gettext('Yes'),
        cancelButtonText: this.$gettext('No'),
        type: 'warning'
      }).then(() => {
        this.$emit('close-edit')
      }).catch(() => {})
    },
    addImage (imageFileName) {
      this.souvenirForm.newImages.push(imageFileName)
      this.souvenirForm.images.push(imageFileName)
    },
    removeImage (imageFileName) {
      this.souvenirForm.removedImages.push(imageFileName)
      this.souvenirForm.images.splice(this.souvenirForm.images.indexOf(imageFileName), 1)
      this.souvenirForm.newImages.splice(this.souvenirForm.newImages.indexOf(imageFileName), 1)
    },
    submitForm (formName) {
      if (this.souvenirForm.images.length === 0) {
        this.souvenirForm.images = [].concat(this.souvenirForm.newImages)
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.loadedForm) {
            this.updateForm()
          } else {
            this.uploadForm()
          }
        }
      })
    }
  }
}
</script>)

(<style>
.input-style {
  margin-top: 1%;
}
.update-form {
  padding: 5%;
}
.url-component {
  max-height: 250px;
  width: 100%;
}
</style>)



// WEBPACK FOOTER //
// src/components/Souvenir-Create-Update-Form.vue